import { UserAvatar } from '@/components/common/user-avatar';
import { customerAvatar } from '@/lib/avatar';

import styles from './cells.module.scss';
import { textCell } from './text-cell';

export type PersonCellOptions = {
  avatarUrl?: string;
  secondary?: string;
};

export function personCell(name: string, { avatarUrl, secondary }: PersonCellOptions = {}) {
  return (
    <span className={styles.person}>
      {/* Fall back to a deterministic illustration avatar (keyed on name) so every person column
          renders one consistently; an explicit avatarUrl always wins. */}
      <UserAvatar name={name} src={avatarUrl ?? customerAvatar(name)} size={18} />
      <span className={styles.personText}>
        {/* Truncates inside a bounded (ADR-0032) column rather than painting over its neighbours,
            with the full name one hover away (ADO 121002 / 120994). */}
        {textCell(name)}
        {secondary ? <span className={styles.personSecondary}>{secondary}</span> : null}
      </span>
    </span>
  );
}
